import 'fullscreen-api-polyfill'
import S360Application from './application'
export default S360Application
